import Image from "next/image";
import { Trans, useTranslation } from "next-i18next";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";
import LinkButton from "@sellernote/ui/src/sds-v2/components/button/Button/LinkButton";
import FourChevronRightIcon from "@sellernote/ui/src/sds-v2/components/svgIcons/FourChevronRightIcon";

import Styled from "./index.styles";

const CLIENT_INTERVIEW_URL =
  "https://www.ship-da.com/blog/category/-%EA%B3%A0%EA%B0%9D-%EC%84%B1%EA%B3%B5%EC%82%AC%EB%A1%80?utm_source=inblog&utm_medium=referral&utm_campaign=homepage&utm_id=customer_main&utm_content=inblog_customer_main";

export default function LandingSectionLogos() {
  const { isMobile } = useCheckIsMobile();

  const { t } = useTranslation(["page-company"]);

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  return (
    <Styled.containerWrapper ref={target}>
      <Styled.container>
        <h3
          className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
        >
          <Trans
            i18nKey="page-company:로고섹션_타이틀"
            components={{ mobileBr: <br className="only-mobile" /> }}
          />
        </h3>

        <Styled.logoImageContainer>
          <Styled.imageWrapper
            className={`logo-image-1 fade-in-animation ${
              isActivatedTarget ? "active" : ""
            }`}
          >
            <Image
              src={
                isMobile
                  ? "/assets/images/company/logo-section-1-m.webp"
                  : "/assets/images/company/logo-section-1.webp"
              }
              alt={`section-image`}
              width={isMobile ? 328 : 1160}
              height={isMobile ? 33 : 60}
              placeholder="blur"
              blurDataURL="/assets/images/landing/section-image-blur-data.png"
            />
          </Styled.imageWrapper>

          <Styled.imageWrapper
            className={`logo-image-2 fade-in-animation ${
              isActivatedTarget ? "active" : ""
            }`}
          >
            <Image
              src={
                isMobile
                  ? "/assets/images/company/logo-section-2-m.webp"
                  : "/assets/images/company/logo-section-2.webp"
              }
              alt={`section-image`}
              width={isMobile ? 328 : 1160}
              height={isMobile ? 33 : 60}
              placeholder="blur"
              blurDataURL="/assets/images/landing/section-image-blur-data.png"
            />
          </Styled.imageWrapper>

          {isMobile && (
            <>
              <Styled.imageWrapper
                className={`logo-image-3 fade-in-animation ${
                  isActivatedTarget ? "active" : ""
                }`}
              >
                <Image
                  src={"/assets/images/company/logo-section-3-m.webp"}
                  alt={`section-image`}
                  width={328}
                  height={33}
                  placeholder="blur"
                  blurDataURL="/assets/images/landing/section-image-blur-data.png"
                />
              </Styled.imageWrapper>

              <Styled.imageWrapper
                className={`logo-image-4 fade-in-animation ${
                  isActivatedTarget ? "active" : ""
                }`}
              >
                <Image
                  src={"/assets/images/company/logo-section-4-m.webp"}
                  alt={`section-image`}
                  width={328}
                  height={33}
                  placeholder="blur"
                  blurDataURL="/assets/images/landing/section-image-blur-data.png"
                />
              </Styled.imageWrapper>
            </>
          )}
        </Styled.logoImageContainer>

        <LinkButton
          theme="secondary"
          borderType="outlined"
          size="normal"
          href={CLIENT_INTERVIEW_URL}
          label={t("page-company:로고섹션_고객인터뷰읽기_버튼")}
          iconInfo={{
            Icon: FourChevronRightIcon,
            position: "right",
          }}
          className={`custom-link-button fade-up-animation ${
            isActivatedTarget ? "active" : ""
          }`}
        />
      </Styled.container>
    </Styled.containerWrapper>
  );
}
